import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import FormCheckboxSwitchComponent from 'webapp/components/form/checkbox-switch';
import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';

import type Block from 'webapp/models-custom/block';

interface Args {
	blockM: Block;
}

export default class OnlyMainMetricDimensionsComponent extends Component<Args> {
	@service('popup') declare popupService: Service.Popup;

	@tracked isInfoPopupOpen = false;

	get block(): Block {
		return this.args.blockM;
	}

	get selected(): boolean {
		return !!this.block.onlyMainMetricDimensions;
	}

	get text() {
		return 'Show only dimensional values matching the main metric';
	}

	get tooltipText(): string {
		return 'When this option is enabled, only dimension values with data for the main metric (sorting column) will be shown in the table.';
	}

	@action
	changeSelected(selected: boolean): void {
		const block = this.block;
		block.onlyMainMetricDimensions = selected;
		block.blockSetup.saveBlock();
	}
	<template>
		<div class="row row--toggle metric-dimensions-toggle">
			<FormCheckboxSwitchComponent
				@name="onlyMainMetricDimensions"
				@selected={{this.selected}}
				@onChange={{this.changeSelected}}
			/>
			<label>
				{{this.text}}
				<ToolTipWithIconComponent
					@text={{this.tooltipText}}
					@iconName="Question"
					@maxWidth={{230}}
				/>
			</label>
		</div>
	</template>
}
